// src/Context/ToastContext.jsx
// Sistema de pop-ups (toasts) in-app. Cualquier componente puede disparar uno
// con useToast().showToast({ type, title, message, onClick, duration }).
import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import ToastContainer from '../components/Toast/ToastContainer';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  const showToast = useCallback(({ type = 'default', title, message, onClick, duration = 5000 }) => {
    const id = ++idRef.current;
    // Tope de 4 toasts visibles: descarta el más viejo si se acumulan.
    setToasts(prev => [...prev.slice(-3), { id, type, title, message, onClick, duration }]);
    return id;
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, removeToast }}>
      {children}
      <ToastContainer toasts={toasts} onDismiss={removeToast} />
    </ToastContext.Provider>
  );
}

export function useToast() {
  // Fallback no-op si se usa fuera del provider (no rompe).
  return useContext(ToastContext) ?? { showToast: () => {}, removeToast: () => {} };
}
